import { createContext, useMemo, type ReactNode } from 'react';
import { BRANDS, type Brand, type BrandConfig } from './brands';
import { detectBrand } from './detectBrand';

export const BrandContext = createContext<BrandConfig | null>(null);

interface Props {
  children: ReactNode;
  /** Test/storybook escape hatch. Production always detects from hostname. */
  brand?: Brand;
}

export function BrandProvider({ children, brand }: Props) {
  const config = useMemo(() => BRANDS[brand ?? detectBrand()], [brand]);

  // <html data-brand> is already set by the inline script in index.html; this
  // only matters when a test mounts the provider with an explicit brand.
  if (document.documentElement.dataset['brand'] !== config.id) {
    document.documentElement.dataset['brand'] = config.id;
  }

  return <BrandContext.Provider value={config}>{children}</BrandContext.Provider>;
}
